import { render, staticRenderFns } from "./ConfigAlertCommand.vue?vue&type=template&id=723d7237&scoped=true"
import script from "./ConfigAlertCommand.vue?vue&type=script&lang=js"
export * from "./ConfigAlertCommand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d7237",
  null
  
)

export default component.exports